/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material';

import { CIColors } from 'shared';

type MuiSwitchComponent = {
  defaultProps?: ComponentsProps['MuiSwitch'];
  styleOverrides?: ComponentsOverrides['MuiSwitch'];
  variants?: ComponentsVariants['MuiSwitch'];
};

export const SwitchComponent: MuiSwitchComponent = {
  styleOverrides: {
    root: {
      height: '24px',
      width: '48px',
      padding: '4px',
      overflow: 'visible',
      '&.Mui-disabled': {
        opacity: '0.6',
      },
    },
    switchBase: {
      top: '-7px',
      left: '-4px',
      '&$checked + $track': {
        opacity: 1,
        backgroundColor: `${CIColors.Tertiary}20`,
      },
      '&$disabled + $track': {
        opacity: 1,
      },
    },
    track: {
      borderRadius: '10px',
      backgroundColor: '#F2F3F4',
      opacity: 1,
    },
    checked: {},
    colorPrimary: {
      color: '#BEC2C6',
      '&:hover': {
        '&$checked + $track': {
          backgroundColor: `${CIColors.Primary}20`,
        },
      },
      '&$checked': {
        color: CIColors.Primary,
      },
      '&$checked + $track': {
        backgroundColor: '#F2F3F4',
      },
      '&$disabled:not($checked) + $track': {
        backgroundColor: '#F2F3F4',
      },
    },
    colorSecondary: {
      color: '#BEC2C6',
      '&:hover': {
        '&$checked + $track': {
          backgroundColor: `${CIColors.Tertiary}20`,
        },
      },
      '&$checked': {
        color: CIColors.Tertiary,
      },
      '&$checked + $track': {
        backgroundColor: '#F2F3F4',
      },
      '&$disabled:not($checked) + $track': {
        backgroundColor: '#F2F3F4',
      },
    },
  },
};
